const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

const shortMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

export const today = () => new Date()

export const monthsFromDate = (date, howMany) => {
  const nd = new Date(date.getTime())
  return new Date(nd.setMonth(nd.getMonth() + howMany))
}

export const monthsFromNow = (howManyMonths) => monthsFromDate(today(), howManyMonths)

export const monthYear = (date) => `${monthNames[date.getMonth()]} ${date.getFullYear()}`

export const shortMonthYear = (date) => `${shortMonthNames[date.getMonth()]} '${date.getYear() - 100}`

export const shortMonth = (str) => str.slice(0, 3)

/*
 * Sorts dates in chronological order.
 * Concat prevents the original from mutating.
 */
export const sort = (dates) => dates.concat().sort((a, b) => a - b)

export const daysBetween = (from, to) => Math.round((to.getTime() - from.getTime()) / 1000 / 60 / 60 / 24)

/*
 * Supports either from and to (dates)
 * or a single number representing a number
 * of dates.
 */
export const timeTo = (daysOrFrom, to) => {
  const days = typeof daysOrFrom === "number" ? daysOrFrom : daysBetween(daysOrFrom, to)
  const years = days / 365 >= 1 ? Math.round(days / 365, 0) : null
  let remainder = days - years * 365
  const months = remainder > 0 ? Math.round(remainder / 30, 0) : null
  const yp = years && years > 1 ? "s" : ""
  const y = years ? `${years} year${yp}` : ""
  const mp = months && months > 1 ? "s" : ""
  const m = months ? `${months} month${mp}` : ""
  const ym = years && months ? " and " : ""
  return `${y}${ym}${m}`
}
